export const DeviceStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};
